import { type AnyAbility, defineAbility } from '@casl/ability';
import { createContext } from 'react';

export const AbilityContext = createContext<AnyAbility>(
  defineAbility(() => null)
);
